window.ClienteNaoCadastradoController = ControllerBase.extend({
    name: "ClienteNaoCadastradoController",
    framework: "knockout",
    region: "#cliente-nao-cadastrado-container",

    ajax: function () {
        
        var data = {
            identificadorOrcamento: this.orcamento ? this.orcamento.get("IdentificadorOrcamento") : null
        };


        this.Novo = !this.orcamento.get("ClienteNaoCadastrado");


        return {
            url: "/Cliente/_ClienteNaoCadastrado",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString(data)
        };
    },

    events: {
        'click #incluir-endereco': "incluirEndereco"
    },

    formConfig: {
        selector: "#form-cadastro-cliente",
        submit: {
            selector: "#salvar-cliente",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'CpfCnpj': {
                required: function () {
                    return !this.model.Nome();
                },
                validateCpfCnpj: true
            },
            'Nome': {
                required: function () {
                    return !this.model.CpfCnpj();
                }
            }
        },
        messages: {
            'CpfCnpj': {
                required: 'CPF/CNPJ ou Nome é obrigatório.',
                validateCpfCnpj: 'O campo "CPF/CNPJ" é inválido.'
            },
            'Nome': {
                required: ''
            },
        },
        ignore: []

    },

    validarNome: function () {
        return (this.model.CpfCnpj() === '');
    },

    validarCPFCNPJ: function () {
        return (this.model.Nome() === '');
    },

    renderizado: function () {
        if (this.Novo) {
            $('#cadastrar-cliente').hide();
        }
        $("#CpfCnpj").focus();
    },

    antesRenderizacaoCompleta: function () {

        if (this.orcamento) {

            this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function () {


                    if (typeof this
                        .currentRegion ==
                        "undefined" ||
                        typeof this.currentRegion.options == "undefined") {
                        return;
                    }

                    switch (this.currentRegion.options.el) {
                        case "#cliente-nao-cadastrado-container":
                        case "#editar-endereco-region":
                            this.parent.limparCliente();
                            break;
                    }

                },
                    this)
            },
                true);
        }

    },

    bairrosPreCadastradosSelect2Options: {
        ajax: {
            url: "/Comum/ListarBairrosPreCadastrados",
            method: "post",
            data: function (params) {
                return {
                    bairro: params.term
                };
            },
            processResults: function (data, page) {

                if (data.Error) {
                    return { results: null };
                }

                return {
                    results: $.map(data,
                        function (item) {
                            return { id: item.Nome, text: item.Nome };
                        })
                };
            }
        },
        delay: 250,
        dataType: "json",
        minimumInputLength: 1
    },

    antesBinding: function () {

        if (!this.model.Enderecos || !this.model.Enderecos()) {
            this.appendToModel({ name: 'Enderecos', value: [] });
        }

        if (!this.model.BairrosPreCadastrados) {
            this.appendToModel({ name: "BairrosPreCadastrados", value: [] });
        }

        if (this.model.Bairro && this.model.Bairro() && this.model.BairrosPreCadastrados) {
            this.model.BairrosPreCadastrados.removeAll();
            this.model.BairrosPreCadastrados([{ Nome: this.model.Bairro() }]);
        }

        if (this.model.CodigoCidade && this.model.CodigoCidade()) {
            this.codigoCidade = this.model.CodigoCidade();
        }

        this.cpfCnpj = this.model.CpfCnpj();

    },

    aposBinding: function () {

        global.applyConditionalMask({
            triggerElement: this.currentRegion.el + ' input[name="CpfCnpj"]',
            triggerEvent: "keydown",
            initialMask: "cpf",
            options: {
                removeMaskOnSubmit: false
            },
            masks: [
                {
                    name: "cpf",
                    mask: "999.999.999-99[9][9][9]",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    },
                    condition: function (e) {
                        if (e
                            .which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    }
                },
                {
                    name: "cnpj",
                    mask: "99.999.999/9999-99",
                    initialCondition: function (e) {

                        var value = $(e.target).inputmask("unmaskedvalue");

                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    },
                    condition: function (e) {

                        if (e
                            .which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");

                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    }
                }
            ]
        });

        $('a[data-toggle="tab"]', this.region.$el).on("shown.bs.tab", $.proxy(this.tabSelecionada, this));
        $("input").on('focus', function () { $(this).select(); });

    },

    limpar: function () {

        this.model.CpfCnpj(undefined);
        this.model.Nome(undefined);
        this.model.InscricaoEstadual(undefined);
        this.model.Contribuinte(undefined);
        this.model.InscricaoSuframa(undefined);
        this.model.Apelido(undefined);
        this.model.Contato(undefined);
        this.model.Enderecos.removeAll();
    },

    salvar: function () {
        if (!global.isFormValid("#form-cadastro-cliente")) {
            return;
        }

        var self = this;
        var d = {
            identificadorOrcamento: this.orcamento ? this.orcamento.get("IdentificadorOrcamento") : null,
            cliente: this.toJS(this.model)
        };

        global.ajax({
            url: '/Orcamento/SalvarClienteNaoCadastrado',
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(d),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }
                global.showSuccessMessage("Registro atualizado com sucesso!");
                self.orcamento.set("ClienteNaoCadastrado", true);
                self.orcamento.set("NomeCliente", self.model.Nome());
                $('#cadastrar-cliente').show()
                self.Novo = false;
                self.parent.parent.mostrarNomeCliente();
            }
        });
    },

    incluirEndereco: function (e) {

        if (e) {
            e.preventDefault();
        }


        this.editarEnderecoClienteController = this.showView({
            region: {
                name: "editarEnderecoRegion",
                selector: "#editar-endereco-region"
            },
            controller: {
                type: EditarEnderecoClienteController,
                args: {
                    cliente: this.model,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    readOnly: this.readOnly,
                    clienteNaoCadastrado: true,
                }
            }
        });

    },

    editarEndereco: function (model) {

        var m = ko.mapping.fromJS(ko.mapping.toJS(model));

        m.editando = true;
        m.index = model.index ? model.index() : undefined;

        this.editarEnderecoClienteController = this.showView({
            region: {
                name: "editarEnderecoRegion",
                selector: "#editar-endereco-region"
            },
            model: m,
            controller: {
                type: EditarEnderecoClienteController,
                args: {
                    cliente: this.model,
                    endereco: model,
                    editando: true,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    readOnly: this.readOnly,
                    clienteNaoCadastrado: true,
                }
            }
        });

    },

    enderecoEditado: function (endereco) {

        if (!endereco.editando && endereco.Novo) {
            this.model.Enderecos.push(endereco);

            var self = this;

            $.each(this.model.Enderecos(),
                function (i) {

                    self.appendToModel({
                        name: "index",
                        value: i,
                        model: this
                    });

                });

        }

        if (this.editarEnderecoClienteController) {
            this.editarEnderecoClienteController.clearRegion();
            this.editarEnderecoClienteController.hide();
            this.show();
        }

    },

    selecionarEndereco: function (model) {

        if (!this.quantidadeEnderecosSelecionados) {
            this.quantidadeEnderecosSelecionados = 0;
        }

        if (model.selecionado) {
            model.selecionado(!model.selecionado());

            this.quantidadeEnderecosSelecionados = this
                .quantidadeEnderecosSelecionados +
                (model.selecionado() ? 1 : -1);

        } else {
            this.appendToModel({ name: "selecionado", value: true });
        }

        var permitirEditar = true;

        $.each(this.model.Enderecos(),
            function () {
                if (this.selecionado() && !this.PermitirEditar()) {
                    permitirEditar = false;
                    return false;
                }
            });

        this.model.possuiEnderecoSelecionado(this.model.permitirAlterarDadosBasicos() &&
            this.quantidadeEnderecosSelecionados > 0 &&
            permitirEditar);

    },

    excluirEndereco: function () {

        for (var i = this.model.Enderecos().length - 1; i >= 0; i--) {
            var model = this.model.Enderecos()[i];

            if (model.Novo && model.selecionado && model.selecionado()) {
                this.model.Enderecos.remove(model);
                global.showSuccessMessage("Endereço excluído com sucesso.");
            }

        }

        this.quantidadeEnderecosSelecionados = 0;
        this.model.possuiEnderecoSelecionado(false);

    },

    tabSelecionada: function (e) {

        var name = $(e.target).attr("aria-controls");

        switch (name) {
            case "tab-dados-basicos":
                break;
            case "tab-enderecos":

                if (!this.model.Enderecos || !this.model.Enderecos() || this.model.Enderecos().length == 0) {
                    //this.incluirEndereco();
                }

                break;
        }
    },

    validarObterCliente: function (e) {

        if (!e) {
            return;
        }

        if (e.preventDefault) {
            e.preventDefault();
        }

        var self = this;
        var cpfCNPJ = e.target ? $(e.target).val() : this.model.CpfCnpj();
        if (cpfCNPJ === "") {
            return;
        }
        
        global.ajax({
            url: "/Orcamento/_ValidarObterClienteNaoCadastrado",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento ? this.orcamento.get("IdentificadorOrcamento") : null,
                CpfCnpj: cpfCNPJ
            },
            success: function (data) {
                if (!data || data.HasErrors) {
                    if (data && data.HasErrors) {
                        self.model.CpfCnpj("")
                    }
                    return;
                }
                self.atualizar(data);
            }
        });

    },

    atualizar: function (data) {

        if (!data) {
            return;
        }

        this.limpar();
        this.model.CpfCnpj(data.CpfCnpj);
        this.model.Nome(data.Nome);
        this.model.InscricaoEstadual(data.InscricaoEstadual);
        this.model.Contribuinte(data.Contribuinte);
        this.model.InscricaoSuframa(data.InscricaoSuframa);
        this.model.Apelido(data.Apelido);
        this.model.Contato(data.Contato);
        if (data.Enderecos.length > 0) {
            var endereco = data.Enderecos[0]
            endereco.PermitirEditar = true;
            endereco = ko.mapping.fromJS(endereco);
            endereco.editando = false;
            endereco.Novo = true;
            this.enderecoEditado(endereco);
        }
        var x = 1;
    },

    salvarCadastrado: function() {

        if (this.cadastrarClienteCallBack) {
            this.cadastrarClienteCallBack();
        }

    }


});